/**
 * Opens when `staticConfig` flag is set.
 */
const config = {
  data: {
    config: {
      apiChatStartURL: "https://www.familyassets.com/api/chat/start/4428",
      apiChatUpdateURL: "https://www.familyassets.com/api/chat/update/4428",
      apiButtonURL: "https://www.familyassets.com/api/button/update/4428",
      apiLocationsURL: "http://example.com/123/",
      backgroundColor: "#f5f5f7",
      brandColor: "#14386e",
      buttonColor: "#14386e",
      fontSize: "14px",
      // "teaserDotColor": "red",
      // "teaserScrollDelay": "20px",
      color: "#121212",
      createURL: "https://www.familyassets.com/api/create/assisted-living/california/val-verde/test-community",
      fontFamily: "helvetica neue",
      iconLogo:
        "https://familyassets.s3-us-west-2.amazonaws.com/chat_speech_bubble_communication_interaction_-_29-512.png",
      introText: "Hi! Nice to meet you.",
      pause: 1,
      showMaxTimes: null,
      maxPhoneAttempts: 3,
      teaser: "Hey there, is there something I can help you find?",
      customJavascript: "console.log('very custom javascript');",
      images: [
        "https://familyassets.s3.amazonaws.com:443/uploaded_facility/8448123461733ccfcf7493f0a61817c0.png",
        "https://familyassets.s3.amazonaws.com:443/uploaded_facility/17383c03b5dbe8a756c563347a824c4b.png",
        "https://loveincorporated.blob.core.windows.net/contentimages/gallery/03211459-0607-4d07-8a6c-9966e3820a7d-Mount-Kirkjufell-Iceland.jpg",
        "https://theyearsproject.com/wp-content/uploads/2019/05/lovatnet-lake-beautiful-nature-norway_bpxjbou08l__D.mov.00_00_02_22.Still001-1024x576.jpg",
        "https://envato-shoebox-0.imgix.net/184d/b9fa-4141-46ca-9329-7317bfa18d2d/DJI_0635_.jpg?auto=compress%2Cformat&fit=max&mark=https%3A%2F%2Felements-assets.envato.com%2Fstatic%2Fwatermark2.png&markalign=center%2Cmiddle&markalpha=18&w=700&s=dabc304365da5ff9bbe9633d57bea8ce",
      ],
      floorplans: [
        {
          id: 7,
          name: "Amber",
          care_types: [],
          room_size: "Studio",
          care_description: null,
          image:
            "https://www.pegasusseniorliving.com/tucson-place-at-ventana-canyon/wp-content/uploads/sites/34/2019/09/Tucson-Place-Web-Amber.png",
          num_baths: 1,
        },
        {
          id: 8,
          name: "Crystal",
          care_types: [],
          room_size: "Studio",
          care_description: null,
          image:
            "https://www.pegasusseniorliving.com/tucson-place-at-ventana-canyon/wp-content/uploads/sites/34/2019/09/Tucson-Place-Web-Crystal.png",
          num_baths: 1,
        },
        {
          id: 4737,
          name: "Studio Apartment",
          care_types: [],
          room_size: "Studio",
          care_description: null,
          image: "https://familyassets.s3.amazonaws.com:443/uploaded_facility/8c1688fbcbb20dd424fbfe64184aa3e9.jpeg",
          num_baths: 1,
        },
        {
          id: 2918,
          name: "Blue Topaz",
          care_types: ["assisted", "memory"],
          room_size: "Studio",
          care_description: "",
          image: "https://familyassets.s3.amazonaws.com:443/uploaded_facility/5c4be26cc637b35ec8b809e0b12409e9.png",
          num_baths: 1,
        },
      ],
      digital_tours: [
        '<iframe src="https://cdn.bitdegree.org/learn/test-iframe.htm" width="90%" height="300px"></iframe>',
        // '<iframe height="800" width="100%" src="https://spectrumretirementvr.com/peakview.html" frameborder="0"></iframe>'
      ],
      buttons: [
        {
          id: 4,
          customCSS: "display:block;",
          cssSelector: ".html-content p",
          htmlContent: "Schedule Tour",
          moduleToOpen: 9,
          urlLimit: null,
          replace: "append", // replace|append|hijack
        },
      ],
      modulesByName: {
        OPEN_PRICING: 2,
        OPEN_SCHEDULE_TOUR: 9,
        ANSWER_FLOW: 8,
        OPEN_FLOORPLAN: 61,
        OPEN_GALLERY: 60,
      },
      prices: [
        {
          cost: 4031,
          name: "Assisted Living",
          discount: {
            text: "discount text",
            amount: 555,
          },
        },
        {
          cost: 5399,
          name: "Memory Care",
          discount: {
            text: "discount text",
            amount: 1234,
          },
        },
      ],
    },
    modules: {
      "1": {
        action: null,
        answers: [
          {
            action: 2,
            text: "Pricing",
          },
          {
            action: 8,
            text: "Ask A Question",
          },
          {
            action: 9,
            text: "Schedule A Tour",
          },
          {
            action: 22,
            text: "Job Inquiry",
          },
          {
            action: 23,
            text: "Request A Text Message",
          },
          {
            action: 28,
            text: "Floorplans",
          },
          // {
          //   action: 29,
          //   text: "Eval module",
          // },
          // {
          //   text: "Try submit with eval",
          //   action: 19,
          // },
          {
            text: "See the gallery",
            action: 30,
          },
          // {
          //   text: "Find nearest locations",
          //   action: 31,
          // },
          {
            text: "Nearest locations",
            action: 65,
          },
          {
            text: "Ask us anything!",
            action: 64,
          },
        ],
        key: "what",
        text: "What would you like assistance with?",
        type: "option",
      },
      "30": {
        type: "option",
        role: "gallery",
        images: [
          {
            original: "https://picsum.photos/id/1018/1000/600/",
            thumbnail: "https://picsum.photos/id/1018/250/150/",
          },
          {
            original: "https://picsum.photos/id/1015/1000/600/",
            thumbnail: "https://picsum.photos/id/1015/250/150/",
          },
          {
            original: "https://picsum.photos/id/1019/1000/600/",
            thumbnail: "https://picsum.photos/id/1019/250/150/",
          },
        ],
      },
      "31": {
        type: "text",
        key: "zip",
        text: "Please enter ZIP code",
        action: 32,
      },
      "32": {
        type: "locations",
        answers: [
          {
            action: 33,
            text: "View All Locations",
            id: 111,
          },
          {
            action: 1,
            text: "Back",
            id: 222,
          },
        ],
      },
      "33": {
        type: "link",
        link_href: "http://google.com",
      },
      "29": {
        type: "eval",
        action: 1,
        text: "console.log('hello from eval');",
      },
      "10": {
        action: 11,
        key: "first_name",
        text: "What is your name?",
        type: "text",
      },
      "11": {
        action: 13,
        key: "email",
        text: "What is your email?",
        type: "text",
      },
      "12": {
        action: null,
        answers: [
          {
            action: 10,
            text: "Morning",
          },
          {
            action: 10,
            text: "Afternoon",
          },
          {
            action: 10,
            text: "Evening",
          },
        ],
        key: "tour_time",
        text: "What time of day would you like to visit?",
        type: "option",
      },
      "13": {
        action: 14,
        key: "phone",
        text: "What is your phone?",
        type: "phone",
      },
      "14": {
        action: 15,
        key: null,
        text: "",
        type: "submit",
      },
      "15": {
        action: null,
        answers: [
          {
            action: 1,
            text: "Yes, please go back",
          },
          {
            action: null,
            text: "Close Bot",
          },
        ],
        key: "more",
        text: "Your tour is booked! Please let us know if there is anything else we can help with.",
        type: "option",
      },
      "16": {
        action: 17,
        key: "first_name",
        text: "What is your name?",
        type: "text",
      },
      "17": {
        action: 18,
        key: "email",
        text: "What is your email?",
        type: "email",
      },
      "18": {
        action: 19,
        key: "phone",
        text: "What is your phone?",
        type: "phone",
      },
      "19": {
        action: 20,
        key: null,
        text: "console.log('hello from submit eval');",
        type: "submit",
      },
      "2": {
        text: "What level of care you interested in?",
        action: null,
        type: "option",
        key: "care",
        pk: 28930,
        answers: [
          {
            text: "Assisted Living",
            action: 3,
            id: 63937,
          },
          {
            text: "Respite Care",
            action: 3,
            id: 63938,
          },
          {
            text: "Memory Care",
            action: 3,
            id: 63939,
          },
          {
            text: "Retirement Living",
            action: 3,
            id: 63940,
          },
          {
            text: "Not Sure",
            action: 3,
            id: 63941,
          },
          {
            text: "Other",
            action: 3,
            id: 63942,
          },
        ],
      },
      "20": {
        action: null,
        answers: [
          {
            action: 1,
            text: "Yes, please go back",
          },
          {
            action: null,
            text: "Close Bot",
          },
        ],
        key: "more",
        text:
          "Thank you! Your question has been received, and someone will be in touch soon to get you an answer. Is there anything else we can help with?",
        type: "option",
      },
      "22": {
        action: 13,
        answers: [
          {
            action: null,
            id: 63898,
            text: "Happy Hour",
          },
          {
            action: null,
            id: 63899,
            text: "Music Activities",
          },
          {
            action: null,
            id: 63900,
            text: "Exercise Classes",
          },
          {
            action: null,
            id: 63901,
            text: "Game Night & Bingo",
          },
          {
            action: null,
            id: 63902,
            text: "Cooking",
          },
          {
            action: null,
            id: 63903,
            text: "Group Outings",
          },
          {
            action: null,
            id: 63904,
            text: "No, Thank you",
          },
        ],
        key: "what",
        pk: 28921,
        text:
          "Please tell us if you would like to learn about any of the following activities, so we can better prepare for your tour.",
        type: "multi_option",
      },
      "23": {
        action: 24,
        key: "phone",
        text: "What is your phone number?",
        type: "phone",
      },
      "24": {
        action: 25,
        key: "first_name",
        text: "What is your name?",
        type: "text",
      },
      "25": {
        action: 26,
        key: "email",
        text: "What is your email address?",
        type: "text",
      },
      "26": {
        action: 27,
        key: "lead_additional_information",
        text: "",
        type: "sms",
      },
      "27": {
        action: null,
        answers: [
          {
            action: 1,
            text: "Yes, please go back",
          },
          {
            action: null,
            text: "Close Bot",
          },
        ],
        key: null,
        text: "An SMS has been sent to your phone. If there is anything else we can help with, please let us know!",
        type: "option",
      },
      "3": {
        action: 4,
        key: "first_name",
        text: "What is your name?",
        type: "text",
      },
      "28": {
        type: "click",
        cssSelector: ".find-me",
        action: 7,
      },
      "40": {
        action: null,
        answers: [
          {
            action: null,
            text: "Close Bot",
          },
          {
            action: 1,
            text: "Go Back To Start",
          },
        ],
        key: "more",
        role: "pricing",
        text:
          "The price of our community starts at $3,000. Please schedule a visit to learn more about Testing Community.",
        type: "option",
      },
      "41": {
        type: "option",
        role: "inchat_gallery",
        answers: [
          {
            action: null,
            text: "Close Bot",
          },
          {
            action: 1,
            text: "Go Back To Start",
          },
        ],
      },
      "42": {
        type: "option",
        role: "inchat_floorplan",
        answers: [
          {
            action: null,
            text: "Close Bot",
          },
          {
            action: 1,
            text: "Go Back To Start",
          },
        ],
      },
      "43": {
        type: "option",
        role: "inchat_digital_tours",
        answers: [
          {
            action: null,
            text: "Close Bot",
          },
          {
            action: 1,
            text: "Go Back To Start",
          },
        ],
      },
      "4": {
        action: 5,
        key: "phone",
        text: "What is your phone?",
        type: "phone",
      },
      "5": {
        action: 6,
        key: "email",
        text: "What is your email?",
        type: "email",
      },
      "6": {
        action: 7,
        key: null,
        text: "",
        type: "submit",
      },
      "7": {
        action: null,
        answers: [
          {
            action: null,
            text: "Close Bot",
          },
          {
            action: 1,
            text: "Yes, please go back",
          },
        ],
        key: "more",
        text: "The price of this community is $30. Please let us know if there is anything else we can help with.",
        type: "option",
      },
      "8": {
        action: 16,
        key: "lead_additional_information",
        text: "Please enter in your question below",
        type: "text",
      },
      "9": {
        action: 12,
        key: "tour_date",
        text: "When would you like to visit?",
        type: "date_picker",
      },
      "64": {
        type: "instant_answers",
        text: "whatever",
      },
      "65": {
        type: "guide",
        answers: [
          {
            text: "Schedule A Tour",
            action: 9,
          },
        ],
      },
    },
  },
};

export default config;
